import React, { cloneElement, isValidElement, useMemo, useState } from 'react';
import { isArray } from 'lodash-es';
import { useNavigationContext } from '~/Hooks';
import { IItemCreationSectionInjectedProps, IItemCreationProps } from './ItemCreation.models';
import { ItemCreationToolbar } from './ItemCreationToolbar';
import { Error } from '~/Components';
import { ItemCreationErrors } from './ItemCreationErrors';

export const useItemCreation = <T extends object>({
  toolbar,
  networkErrors,
  ItemCreationErrorsElement,
  children,
}: Omit<
  IItemCreationProps<T>,
  'initialValues' | 'validate' | 'isLoading' | 'modalTitle' | 'onSave'
>) => {
  const { blockNavigation } = useNavigationContext();
  const [activeSectionIndex, setActiveSectionIndex] = useState(0);
  const [disabled, setDisabled] = useState({} as { [key in keyof T]?: boolean });

  const Toolbar = isValidElement(toolbar)
    ? () => toolbar
    : () => <ItemCreationToolbar headers={toolbar?.headers || []} />;
  const ErrorElement = isValidElement(networkErrors)
    ? () => networkErrors
    : () => <Error error={networkErrors} />;
  const FormikErrorsElement = ItemCreationErrorsElement
    ? () => ItemCreationErrorsElement
    : () => <ItemCreationErrors />;
  const Children = useMemo(
    () =>
      (isArray(children)
        ? children
        : [children]
      ).map((child) => (props: IItemCreationSectionInjectedProps<T>) => cloneElement(child, props)),
    [],
  );

  return {
    blockNavigation,
    Toolbar,
    ErrorElement,
    FormikErrorsElement,
    Children,
    activeSectionIndex,
    setActiveSectionIndex,
    disabled,
    setDisabled,
  };
};
